import UIGridContainerFormatter from './UIGridContainerFormatter';
import { jsx as _jsx } from "react/jsx-runtime";
function GridContainerFormatter({
  containerId,
  contents,
  CrmContainerContentRenderer,
  layout,
  observerManager,
  CardFormatter
}) {
  return /*#__PURE__*/_jsx(UIGridContainerFormatter, {
    containerId: containerId,
    contents: contents,
    CrmContainerContentRenderer: CrmContainerContentRenderer,
    observerManager: observerManager,
    CardFormatter: CardFormatter,
    layout: Object.assign({}, layout, {
      type: 'UIGRID'
    })
  });
}
export default GridContainerFormatter;